// Replace with your actual WhatsApp business number (format: country code + number, no + or spaces)
// Example: For +1 234 567 8900, use: 12345678900
const WHATSAPP_BUSINESS_NUMBER = '7005665616';

/**
 * Generates a WhatsApp order link with pre-filled message
 */
export function generateWhatsAppOrderLink(product, productUrl) {
  const url = productUrl || window.location.href;
  const message = `Hi! I want to order the *${product.name}* by ${product.brand}\n\nPrice: ₹${product.price.toLocaleString('en-IN')}\n\nProduct Link: ${url}`;
  
  return `https://wa.me/${WHATSAPP_BUSINESS_NUMBER}?text=${encodeURIComponent(message)}`;
}

/**
 * Generates a WhatsApp share link for the product
 */
export function generateWhatsAppShareLink(product, productUrl) {
  const url = productUrl || window.location.href;
  const message = `Check out this amazing ${product.category.toLowerCase()} product!\n\n*${product.name}* by ${product.brand}\n\nOnly ₹${product.price.toLocaleString('en-IN')}\n\n${url}`;
  
  return `https://wa.me/?text=${encodeURIComponent(message)}`;
}

/**
 * Shares product using native Web Share API with WhatsApp fallback
 */
export async function shareProduct(product, productUrl) {
  const url = productUrl || window.location.href;
  
  // Check if Web Share API is available
  if (navigator.share) {
    try {
      await navigator.share({
        title: product.name,
        text: `Check out ${product.name} by ${product.brand} - Only ₹${product.price.toLocaleString('en-IN')}`,
        url: url,
      });
      return true;
    } catch (error) {
      // User cancelled or error occurred
      if (error.name !== 'AbortError') {
        console.error('Share failed:', error);
      }
      return false;
    }
  } else {
    // Fallback to WhatsApp share on desktop
    const whatsappUrl = generateWhatsAppShareLink(product, productUrl);
    window.open(whatsappUrl, '_blank');
    return true;
  }
}

/**
 * Opens WhatsApp to order the product
 */
export function orderViaWhatsApp(product, productUrl) {
  const whatsappUrl = generateWhatsAppOrderLink(product, productUrl);
  window.open(whatsappUrl, '_blank');
}
